export default __webpack_public_path__ + "dist/media/Section 1.383f329a.png";